<template>
  <div id="app">
    <Background />
    <div class="content">
      <div class="left">
        <img class="logo-desktop" src="@/assets/logo.svg" alt="midnight motorsport" />
        <div class="logo-mobile">
          <img class="icon" src="@/assets/logo_icon.svg" alt="" />
          <img class="name" src="@/assets/logo_name.svg" alt="midnight motorsport" />
        </div>
        <a href="#" class="address">4101 W Marginal Way SW, Suite B1</a>
        <a class="phone" href="tel:2065356067">206.535.6067</a>
        <a class="email" href="mailto:patrick@midnightmotorsport.com">patrick@midnightmotorsport.com</a>
      </div>
      <div class="right">
        <p class="info">
          For up-to-date content on current projects, shop things, and general car nerd goodness give our Instagram a visit.
        </p>
        <a class="social-instagram" href="https://instagram.com/midnightmotorsport">
          <img src="@/assets/icon_instagram.svg" alt="" />
          <span>@midnightmotorsport</span>
        </a>
        <p class="location">Seattle, WA</p>
      </div>
    </div>
  </div>
</template>

<script>
import Background from '@/components/Background.vue';

export default {
  name: 'app',
  components: {
    Background
  }
};
</script>

<style lang="scss">
$break-4: 1320px;
$break-3: 960px;
$break-2: 800px;
$break-1: 600px;

html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  position: relative;
  width: 100%;
  height: calc(100% - 96px);
  padding: 48px 0;
  font-family: 'PT Sans Narrow', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  color: white;
  transition: background-image 1s ease-in-out;

  @media (max-width: $break-2) {
    height: auto;
    padding: 48px 0 8px;
    min-height: calc(100% - 56px);
  }
}

.loader {
  position: absolute;
  left: 100%;
}

#app::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(black, 0.45);
  z-index: 0;
}

p {
  margin: 0;
  padding: 0;
}

a {
  display: block;
  color: white;
  text-decoration: none;
  transition: color 0.5s;
}

a:hover {
  color: #eee;
}

.content {
  position: relative;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  margin: auto 0;

  @media (max-width: $break-2) {
    flex-direction: column;
  }
}

.left,.right {
  width: 50%;
  padding: 0 52px;

  @media (max-width: $break-3) {
    padding: 0 36px;
  }

  @media (max-width: $break-2) {
    width: 80%;
    text-align: center;
  }
}

.left {
  text-align: right;

  @media (max-width: $break-2) {
    text-align: center;
  }
}

.right {
  position: relative;
  border-left: 2px solid white;

  @media (max-width: $break-2) {
    border-left: none;

    &::after {
      content: '';
      position: absolute;
      width: 124px;
      height: 2px;
      background: white;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.logo-desktop {
  margin: -16px 0 -16px;
  max-width: 480px;

  @media (max-width: $break-2) {
    display: none;
  }
}

.logo-mobile {
  display: none;

  @media (max-width: $break-2) {
    display: block;
  }

  img {
    display: block;
    margin: 48px auto 12px;
  }

  .icon {
    margin-top: 0;
    width: 96px;
    height: 96px;

    @media (max-width: $break-1) {
      width: 64px;
      height: 64px;
    }
  }

  .name {
    width: 320px;

    @media (max-width: $break-1) {
      width: 220px;
    }
  }
}

.address {
  font-size: 30px;

  @media (max-width: $break-4) {
    font-size: 24px;
  }

  @media (max-width: $break-3) {
    font-size: 22px;
  }

  @media (max-width: $break-1) {
    font-size: 18px;
  }
}

.phone {
  font-size: 40px;
  font-weight: 600;

  @media (max-width: $break-4) {
    font-size: 32px;
  }

  @media (max-width: $break-3) {
    font-size: 30px;
  }

  @media (max-width: $break-1) {
    font-size: 26px;
  }
}

.email {
  margin: 0 0 16px;
  font-size: 30px;

  @media (max-width: $break-4) {
    font-size: 24px;
  }

  @media (max-width: $break-3) {
    font-size: 22px;
  }

  @media (max-width: $break-2) {
    margin: 0 0 28px;
  }

  @media (max-width: $break-1) {
    font-size: 18px;
  }
}

.info {
  margin: 8px 0 18px;
  font-size: 26px;
  max-width: 520px;

  @media (max-width: $break-4) {
    font-size: 22px;
    max-width: 440px;
  }

  @media (max-width: $break-3) {
    font-size: 20px;
    max-width: 400px;
  }

  @media (max-width: $break-2) {
    margin: 24px auto;
  }

  @media (max-width: $break-1) {
    font-size: 16px;
    max-width: 360px;
  }
}

.social-instagram {
  display: flex;
  margin: 12px 0 8px;
  align-items: center;

  @media (max-width: $break-2) {
    margin: 12px auto 8px;
    justify-content: center;
  }

  img {
    width: 42px;
    height: 42px;

    @media (max-width: $break-1) {
      width: 20px;
      height: 20px;
    }
  }

  span {
    margin: 0 16px;
    font-size: 26px;

    @media (max-width: $break-4) {
      font-size: 22px;
    }

    @media (max-width: $break-3) {
      font-size: 20px;
    }

    @media (max-width: $break-1) {
      margin: 0 8px;
      font-size: 16px;
    }
  }
}

.location {
  display: none;
  font-size: 16px;

  @media (max-width: $break-2) {
    display: block;
    margin: 48px 0 8px;
  }
}

</style>
